import { lazy } from "react";
import { Route } from "react-router";
import { CMSPagesManager } from "../CMS/Pages/CMSPagesManager";
import { CMSTemplatesManager } from "../CMS/Pages/CMSTemplatesManager";
import { SettingsRouteBoundary } from "./SettingsRouteBoundary";
import { CMSRouteContext } from "./CMSRouteContext";
import { MediaLibraryProtection } from "./MediaLibraryProtection";
import { CMSPagesProtection } from "./CMSPagesProtection";

const SettingsContentHomeLazy = lazy(() => import("../SettingsContentHome"));
const CMSPageEditorLazy = lazy(() =>
    import("../CMS/Pages/CMSPageEditor").then((module) => ({ default: module.CMSPageEditor })),
);
const MediaLibraryLazy = lazy(() => import("../MediaLibrary/MediaLibrary"));

export const contentRoutes = () => (
    <>
        <Route
            path="content"
            element={
                <SettingsRouteBoundary>
                    <SettingsContentHomeLazy />
                </SettingsRouteBoundary>
            }
        />
        <Route path="content/pages">
            <Route
                index
                element={
                    <CMSPagesProtection>
                        <CMSPagesManager />
                    </CMSPagesProtection>
                }
            />
            <Route element={<CMSRouteContext />}>
                <Route
                    path=":slug"
                    element={
                        <SettingsRouteBoundary>
                            <CMSPageEditorLazy />
                        </SettingsRouteBoundary>
                    }
                />
            </Route>
        </Route>
        <Route
            path="content/pdf-templates"
            element={
                <CMSPagesProtection>
                    <CMSTemplatesManager />
                </CMSPagesProtection>
            }
        />
        <Route element={<MediaLibraryProtection />}>
            <Route
                path="content/media-library"
                element={
                    <SettingsRouteBoundary>
                        <MediaLibraryLazy />
                    </SettingsRouteBoundary>
                }
            />
        </Route>
    </>
);
